import { DropdownAtomsModule, DropdownMenuModule } from '@anecdotes/design-system/dropdown-menu';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import {
  DataFilterButtonComponent,
  DataFilterFieldComponent,
  DataFilterOptionComponent,
  DataFilterPanelComponent,
  SearchInputComponent,
  SelectedFiltersListComponent,
  SelectedFitlerOptionChipComponent,
  DataSearchComponent,
  SearchResultsPaginationComponent,
  SortDropdownComponent,
  FilterDropdownComponent,
  FilterTabsComponent,
  FilterFieldsGroupComponent
} from './components';
import { DataFilterManagerService, FilterDefinitionStoreService, FilterPanelFacadeService, SearchInstancesManagerService, SearchMessageBusService } from './services';
import { FilterInstanceHelper } from './store/utils';
import * as filterDataState from './store';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { FormControlsModule } from '@anecdotes/design-system/form-controls';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilsModule } from '@anecdotes/design-system/utils';
import { SearchableRowDirective, SearchableTextDirective, SearchScopeDirective, SearchableRowByIdsDirective } from './directives';
import { DirectivesModule } from '@anecdotes/design-system/directives';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    SelectedFiltersListComponent,
    DataFilterButtonComponent,
    DataFilterPanelComponent,
    DataFilterFieldComponent,
    DataFilterOptionComponent,
    SelectedFitlerOptionChipComponent,
    SearchInputComponent,
    DataSearchComponent,
    SearchResultsPaginationComponent,
    SortDropdownComponent,
    SearchScopeDirective,
    SearchableRowDirective,
    SearchableRowByIdsDirective,
    SearchableTextDirective,
    FilterDropdownComponent,
    FilterTabsComponent,
    FilterFieldsGroupComponent,
  ],
  imports: [
    CommonModule,
    MatExpansionModule,
    TranslateModule.forChild(),
    StoreModule.forFeature(filterDataState.featureKey, filterDataState.reducers),
    ButtonsModule,
    SvgIconsModule,
    FormControlsModule,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    DropdownAtomsModule,
    UtilsModule,
    DropdownMenuModule,
    DirectivesModule,
    NgbTooltipModule
  ],
  exports: [
    SelectedFiltersListComponent,
    DataFilterButtonComponent,
    DataFilterPanelComponent,
    DataFilterFieldComponent,
    DataFilterOptionComponent,
    SearchInputComponent,
    DataSearchComponent,
    SearchResultsPaginationComponent,
    SortDropdownComponent,
    SearchScopeDirective,
    SearchableRowDirective,
    SearchableRowByIdsDirective,
    SearchableTextDirective,
    FilterDropdownComponent,
    FilterTabsComponent
  ],
})
export class DataFilterModule {
  static forRoot(): ModuleWithProviders<DataFilterModule> {
    return {
      ngModule: DataFilterModule,
      providers: [
        ...EffectsModule.forFeature(filterDataState.effects).providers,
        FilterDefinitionStoreService,
        DataFilterManagerService,
        FilterPanelFacadeService,
        FilterInstanceHelper,
        SearchInstancesManagerService,
        SearchMessageBusService,
      ],
    };
  }
}
